/* eslint-disable @typescript-eslint/camelcase */
export var style = {
    demo: {
        primary: '#1A1F39',
        primaryDark: '#051d3b',
        primaryLight: '#f9c532',
        accent: '#f9c532',
    },
    test: {
        primary: '#2196F3',
        primaryDark: '#1976D2',
        primaryLight: '#E3F2FD',
        accent: '#FFFFFF',
    },
    ambulans_blekinge: {
        primary: '#215287',
        primaryDark: '#1d4877',
        primaryLight: '#E8EAF6',
        accent: '#ffcc00',
    },
    ambulans_orebro: {
        primary: '#0067B2',
        primaryDark: '#004F9E',
        primaryLight: '#B2DEF2',
        accent: '#5AB031',
    },
    ambulans_vastmanland: {
        primary: '#1f49a1',
        primaryDark: '#103a90',
        primaryLight: '#f8dd00',
        accent: '#f8dd00',
    },
    lakemedel_gavleborg: {
        primary: '#50B848',
        primaryDark: '#388E3C',
        primaryLight: '#E8F5E9',
        accent: '#4058FF',
    },
    polis_appen: {
        primary: '#163c6b',
        primaryDark: '#051d3b',
        primaryLight: '#f9c532',
        accent: '#f9c532',
    },
    strama_gavleborg: {
        primary: '#FFC107',
        primaryDark: '#FFA000',
        primaryLight: '#FFFDE7',
        accent: '#EB1F21',
    },
    strama_jonkoping: {
        primary: '#F44336',
        primaryDark: '#D32F2F',
        primaryLight: '#FFEBEE',
        accent: '#303030',
    },
    strama_nationell: {
        primary: '#5c92c4',
        primaryDark: '#1E88E5',
        primaryLight: '#E3F2FD',
        accent: '#FFD82B',
    },
    ambulans_vasternorrland: {
        primary: '#009fe3',
        primaryDark: '#1E88E5',
        primaryLight: '#E3F2FD',
        accent: '#ffcc00',
    },
    ambulans_norrbotten: {
        primary: '#C73238',
        primaryDark: '#B2292E',
        primaryLight: '#E3F2FD',
        accent: '#E3F2FD',
    },
    strama_orebro: {
        primary: '#9FC53A',
        primaryDark: '#008B39',
        primaryLight: '#DCEBBD',
        accent: '#004F9E',
    },
    ambulans_sormland: {
        primary: '#9D1458',
        primaryDark: '#87124d',
        primaryLight: '#fce8f2',
        accent: '#E9EF4B',
    },
    strama_varmland: {
        primary: '#003c68',
        primaryDark: '#003c68',
        primaryLight: '#66b4ff',
        accent: '#f9b000',
    },
    mps_appen: {
        primary: '#414f5a',
        primaryDark: '#414f5a',
        primaryLight: '#d8e4f0',
        accent: '#eee548',
    },
    raddningstjansten_syd: {
        primary: '#103250',
        primaryDark: '#103250',
        primaryLight: '#fffcf0',
        accent: '#f1b600',
    },
    falck_amb_stockholm: {
        primary: '#FF1E2D',
        primaryDark: '#66182A',
        primaryLight: '#ffff',
        accent: '#ffff',
    },
    falck_amb_gotland: {
        primary: '#FF1E2D',
        primaryDark: '#66182A',
        primaryLight: '#ffff',
        accent: '#ffff',
    },
    softwerk: {
        primary: '#B72C25',
        primaryDark: '#080201',
        primaryLight: '#ffff',
        accent: '#ffff',
    },
    vc_bagis: {
        primary: '#9D1458',
        primaryDark: '#87124d',
        primaryLight: '#fce8f2',
        accent: '#E9EF4B',
    },
    ambulans_kronoberg: {
        primary: '#006633',
        primaryDark: '#003a0b',
        primaryLight: '#ffff',
        accent: '#E9EF4B',
    },
    ambulans_ostergotland: {
        primary: '#0066B3',
        primaryDark: '#0066B3',
        primaryLight: '#a9d7ff',
        accent: '#fed765',
    },
    falu_kommun: {
        primary: '#a63822',
        primaryDark: '#571204',
        primaryLight: '#f3e1dd',
        accent: '#ffffff',
    },
    saters_kommun: {
        primary: '#950024',
        primaryDark: '#950024',
        primaryLight: '#d9c7cc',
        accent: '#ffffff',
    },
    primarvard_sormland: {
        primary: '#9D1458',
        primaryDark: '#87124d',
        primaryLight: '#fce8f2',
        accent: '#E9EF4B',
    },
};
//# sourceMappingURL=style.js.map